import { keys } from '../keys';
import {
  createBillingConfig,
  PriceInterval,
  PriceModel,
  PriceType
} from './schema';

enum Feature {
  FileStorage = 'File Storage',
  Notes = 'Notes',
  AIAssistant = 'AI Assistant',
  TeamCollaboration = 'Team Collaboration',
  AdvancedSecurity = 'Advanced Security',
  PrioritySupport = 'Priority Support'
}

const currency = 'USD';

export const billingConfig = createBillingConfig({
  products: [
    {
      id: 'free',
      name: 'Free',
      description: 'Start for free with 5GB storage and 100 notes.',
      label: 'Get started',
      isFree: true,
      features: [Feature.FileStorage, Feature.Notes, Feature.AIAssistant],
      // Even if it is free, keep the plans and prices to display the interval and currency correctly
      plans: [
        {
          id: 'plan-free-month',
          displayIntervals: [PriceInterval.Month],
          prices: [
            {
              id: 'price-free-month-id', // a placebo ID is fine here
              type: PriceType.Recurring,
              model: PriceModel.Flat,
              interval: PriceInterval.Month,
              cost: 0,
              currency
            }
          ]
        },
        {
          id: 'plan-free-year',
          displayIntervals: [PriceInterval.Year],
          prices: [
            {
              id: 'price-free-year-id', // a placebo ID is fine here
              interval: PriceInterval.Year,
              type: PriceType.Recurring,
              model: PriceModel.Flat,
              cost: 0,
              currency
            }
          ]
        }
      ]
    },
    {
      id: 'pro',
      name: 'Pro',
      description: 'Unlock 50GB storage and unlimited notes.',
      label: 'Get started',
      recommended: true,
      features: [
        Feature.FileStorage,
        Feature.Notes,
        Feature.AIAssistant,
        Feature.TeamCollaboration,
        Feature.AdvancedSecurity,
        Feature.PrioritySupport
      ],
      plans: [
        {
          id: 'plan-pro-month',
          displayIntervals: [PriceInterval.Month],
          trialDays: 7,
          prices: [
            {
              id:
                keys().NEXT_PUBLIC_BILLING_PRICE_PRO_MONTH_ID ||
                'price-pro-month-id', // keep for marketing pages, so you only need to specify id in portal
              interval: PriceInterval.Month,
              type: PriceType.Recurring,
              model: PriceModel.Flat,
              cost: 10,
              currency
            }
          ]
        },
        {
          id: 'plan-pro-year',
          displayIntervals: [PriceInterval.Year],
          trialDays: 7,
          prices: [
            {
              id:
                keys().NEXT_PUBLIC_BILLING_PRICE_PRO_YEAR_ID ||
                'price-pro-year-id', // keep for marketing pages, so you only need to specify id in portal
              interval: PriceInterval.Year,
              type: PriceType.Recurring,
              model: PriceModel.Flat,
              cost: 100,
              currency
            }
          ]
        }
      ]
    }
  ]
});

export const billingConfigDisplayIntervals = Array.from(
  new Set(
    billingConfig.products
      .filter((product) => !product.hidden)
      .flatMap((product) =>
        product.plans.flatMap((plan) => plan.displayIntervals)
      )
      .filter(Boolean)
  )
) as PriceInterval[];
